import ScanRecordTable from "./scanRecordTable.container"

export default ScanRecordTable
